<template functional>
  <div
    class="ui-avatar flex items-center justify-center rounded-full"
    :class="[data.class, data.staticClass]"
    v-on="listeners"
  >
    <img
      v-if="props.imageSrc"
      :src="props.imageSrc"
      :alt="props.imageAlt"
      class="h-full w-full object-cover bg-gray-200"
      :class="props.imageClasses"
    />
    <slot v-else />
  </div>
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: 'Avatar',
    },
    imageClasses: {
      type: [Array, String],
      default: 'rounded-full',
    },
  },
  data: () => ({
    backgroundColors: [
      '#F44336', '#FF4081', '#9C27B0', '#673AB7',
      '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688',
      '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107',
      '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B',
    ],
  }),
};
</script>

<style>
.ui-avatar {
  height: var(--avatar-size, 50px);
  width: var(--avatar-size, 50px);
}
</style>
